module.exports = __webpack_public_path__ + "static/media/Montana2924.f9354f12.jpg";